module.exports = __webpack_public_path__ + "img/license_example.0b187244.png";